import request from "@/utils/request";

// 后端 Spring MVC 按逗号串接收 List 参数，避免 axios 默认的 key[]=1 形式绑定失败。
function normalizeParams(params) {
  const next = {};
  Object.keys(params || {}).forEach(key => {
    const value = params[key];
    if (value === undefined || value === null || value === "") {
      return;
    }
    next[key] = Array.isArray(value) ? value.join(",") : value;
  });
  return next;
}

// 经营分析大屏接口统一为 GET 查询，页面只负责展示和筛选，不在前端拼假数据。
function get(url, params) {
  return request({
    url,
    method: "get",
    params: normalizeParams(params)
  });
}

// 食堂下拉选项。
export function getShopOptions(params) {
  return get("/business/analysis/shop-options", params);
}

// 档口下拉选项，可传 shopIds 过滤。
export function getStallOptions(params) {
  return get("/business/analysis/stall-options", params);
}

// 雷达图按档口模式的档口选项，按周期和食堂过滤。
export function getRadarStallOptions(params) {
  return get("/business/analysis/radar-stall-options", params);
}

// 消费订单统计卡片。
export function getBusinessOverview(params) {
  return get("/business/analysis/overview", params);
}

// 经营综合实力雷达图。
export function getBusinessRadar(params) {
  return get("/business/analysis/radar", params);
}

// 菜品热榜近 30 天趋势。
export function getDishTrend(params) {
  return get("/business/analysis/dish-trend", params);
}

// 三餐明细 Top10。
export function getMealDetail(params) {
  return get("/business/analysis/meal-detail", params);
}

// 档口排名图表和表格。
export function getStallRank(params) {
  return get("/business/analysis/stall-rank", params);
}

// 食堂/档口详情弹窗。
export function getRankDetail(params) {
  return get("/business/analysis/rank-detail", params);
}
